import * as React from "react";

const SvgBook = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="m19.87 4.874-1.925-2.673h-.031a.34.34 0 0 0-.099-.094l-.092-.067A.5.5 0 0 0 17.62 2H4.616a.6.6 0 0 0-.418.177.7.7 0 0 0-.197.438v16.638a1 1 0 0 0 0 .073.5.5 0 0 0 .11.301q.02.038.044.074l1.846 2.078a.6.6 0 0 0 .209.164q.121.058.253.057h12.922c.163 0 .32-.07.435-.196a.7.7 0 0 0 .18-.473V5.29a.7.7 0 0 0-.13-.415M5.233 3.284h11.611v15.3H5.232zm13.537 17.38H6.721l-.658-.743h11.396c.163 0 .32-.07.435-.196a.7.7 0 0 0 .18-.472v-14.7l.695.963z"
    />
    <path
      fill="currentColor"
      d="M13.847 7.963H8.924c-.163 0-.32.07-.435.195a.7.7 0 0 0-.18.473c0 .177.064.347.18.473a.6.6 0 0 0 .435.196h4.923c.163 0 .32-.07.435-.196a.7.7 0 0 0 .18-.473.7.7 0 0 0-.18-.473.6.6 0 0 0-.435-.195M13.847 9.968H8.924c-.163 0-.32.07-.435.196a.7.7 0 0 0-.18.472c0 .178.064.348.18.473a.6.6 0 0 0 .435.196h4.923c.163 0 .32-.07.435-.196a.7.7 0 0 0 .18-.473.7.7 0 0 0-.18-.472.6.6 0 0 0-.435-.196M13.847 11.973H8.924c-.163 0-.32.07-.435.196a.7.7 0 0 0-.18.473c0 .177.064.347.18.472a.6.6 0 0 0 .435.196h4.923c.163 0 .32-.07.435-.196a.7.7 0 0 0 .18-.472.7.7 0 0 0-.18-.473.6.6 0 0 0-.435-.196"
    />
  </svg>
);
export default SvgBook;
